import palette from '../palette';

const buttonOverrides = {
  styleOverrides: {
    outlined: {},
    contained: {
      backgroundColor: palette.common.white,
      '&:hover': {
        backgroundColor: palette.common.neutral,
      },
    },
  },
};

export default buttonOverrides;
